// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3TYUI","range":"MonthRangeSwitch_range__1w2nZ","disabled":"MonthRangeSwitch_disabled__3NjS1"};